import "./datatable.scss";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  teacherColumns,
  teacherRows,
  fetchTeacherRows,
} from "../../datatablesource";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSlug } from "../../SlugContext";
import { serverUrl } from "../../temp";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../loader/Loader";

const TeacherDataTable = () => {
  const [data, setData] = useState(teacherRows);
  const [loading, setLoading] = useState(false);
  const { slugs } = useSlug();
  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const rows = await fetchTeacherRows();
      console.log("jawad", rows);
      setLoading(false);
      setData(Array.from(rows.data));
    };
    getData();
  }, []);
  const handleSaveID = (row) => {
    const teacherId = row.id;
    const classId = row.class_id;
    const subjectId = row.subject_id;

    localStorage.setItem("selected_teacher_id", teacherId);
    localStorage.setItem("selected_class_id", classId);
    localStorage.setItem("selected_subject_id", subjectId);
  };

  const handleDelete = (id) => {
    // Make a DELETE request to the Flask API endpoint
    fetch(`${serverUrl}/del_teacher/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to delete teacher");
        }
        setData(data.filter((item) => item.id !== id));
        toast.success("Teacher deleted successfully!");
      })
      .catch((error) => {
        console.error("Delete error:", error);
        toast.error("Failed to delete subject. Please try again.");
      });
  };
  const listingLinkString = "Coursechapter-Listing";

  const viewLinkString = "Teacher-Single";
  const editLinkString = "Teacher-Edit";
  const newLinkString = "Teacher-New";
  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 300,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            {slugs && slugs.includes(listingLinkString) && (
              <Link
                to={`/teacher/course-chapter`}
                style={{ textDecoration: "none" }}
              >
                <div
                  className="otherButton"
                  onClick={() => handleSaveID(params.row)}
                >
                  Chapters
                </div>
              </Link>
            )}
            {slugs && slugs.includes(viewLinkString) && (
              <Link
                to={`/teacher/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="viewButton">View</div>
              </Link>
            )}
            {slugs && slugs.includes(editLinkString) && (
              <Link
                to={`/teacher/update-teacher/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="editButton">Edit</div>
              </Link>
            )}
            <div
              className="deleteButton disabled"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="datatable">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between w-full gap-3 pb-2 lg:pb-2">
        <div className="text-gray-700 text-2xl">Teachers</div>
        <div className="flex flex-col sm:flex-row gap-2 w-full lg:w-auto">
          {slugs && slugs.includes(newLinkString) && (
            <Link to="/teacher/new" className="commonButton w-full sm:w-auto">
              Add New
            </Link>
          )}
        </div>
      </div>
      {loading ? (
        // <h1 style={{ textAlign: "center", paddingTop: "20%" }}>loading...</h1>
        <Loader fullScreen={false} />
      ) : (
        <DataGrid
          className="datagrid"
          rows={data}
          columns={teacherColumns.concat(actionColumn)}
          pageSize={9}
          rowsPerPageOptions={[9]}
          components={{
            Toolbar: GridToolbar, // Include the GridToolbar in the Toolbar slot
          }}
        />
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default TeacherDataTable;
